import IFrame from './IFrame.view';

export default IFrame;
